import { Component, OnInit } from '@angular/core';
import {MatTab, MatTabChangeEvent, MatTabContent, MatTabGroup} from "@angular/material/tabs";
import { TranslateModule } from "@ngx-translate/core";
import { ActivatedRoute, Router } from '@angular/router';
import {ProjectDetailComponent} from '../project-detail/project-detail.component';
import {ProjectDetailConsumptionComponent} from '../project-detail-consumption/project-detail-consumption.component';
import {ToolTabList} from '../../tool/tool-tab-list/tool-tab-list.component';
import {TabDetailComponent} from '../../base-components/tab-detail.component';

@Component({
  selector: 'wim-project-tab-detail',
  standalone: true,
  imports: [
    MatTab,
    MatTabContent,
    MatTabGroup,
    ProjectDetailComponent,
    ProjectDetailConsumptionComponent,
    TranslateModule,
  ],
  templateUrl: './project-tab-detail.component.html',
  styleUrl: './project-tab-detail.component.scss'
})
export class ProjectTabDetailComponent extends TabDetailComponent {

}
